import React, { useEffect, useState } from 'react'
import { authRepo } from 'src/business/repo/auth-repo'

export const TestScreen = (): React.ReactElement => {
  const [result, setResult] = useState<any>()
  useEffect(() => {
    authRepo()
      .Authorised.permissionsByTenantId({ tenantId: '87f057a1-458d-4a15-9d3a-f8d197801837' })
      .then((data): void => {
        setResult(data)
      })
  }, [])

  return <pre>{JSON.stringify(result, null, 2)}</pre>
}
